/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BudgetSummaryFilterModel {
    getFixupPrototypeFunction() { return BudgetSummaryFilterModel.fixupPrototype; }

    static newInstance(model: Partial<BudgetSummaryFilterModel>): BudgetSummaryFilterModel {
        let obj = Object.assign(new BudgetSummaryFilterModel(), model);
        BudgetSummaryFilterModel.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BudgetSummaryFilterModel>): BudgetSummaryFilterModel {
        if (!model) return null;
        return BudgetSummaryFilterModel.newInstance(<BudgetSummaryFilterModel> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BudgetSummaryFilterModel) {
        if (!obj) return;

        models.BudgetSummaryFilterModel.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BudgetSummaryFilterModel): boolean {
        Object.setPrototypeOf(obj, BudgetSummaryFilterModel.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * The name of the cloud service. For example, AWS.
     */
    cloud: Array<string>;

    /**
     * Specify the cloud account ID to view, cloud account ID is unique can be obtained from the list cloud account api.
     */
    cloud_account_id: Array<string>;

    /**
     * currency of the cost. Example 'currency':'USD'
     */
    currency: models.Currency;

}
